import type { GraphQLFormattedError } from 'graphql';

import { clearSelectedAdAccountIfNotFoundForStatus } from '../../../../utils/errors/clearSelectedAdAccountIfNotFound';
import { getGraphQLErrorHttpStatusFromExtensions } from '../../../../utils/errors/getGraphQLErrorHttpStatus';
import { operationName } from '../mutations/useUpdateLastActivity';

export const tryHandleUpdateLastActivityNotFoundError = (
  graphQLErrors: ReadonlyArray<GraphQLFormattedError>,
  requestOperationName: string,
  variables: Record<string, unknown> | undefined
): boolean => {
  const responseStatus = getGraphQLErrorHttpStatusFromExtensions(graphQLErrors[0]?.extensions);

  if (responseStatus !== 404 || requestOperationName !== operationName) {
    return false;
  }

  const adAccountId = variables?.adAccountId;

  if (typeof adAccountId === 'string') {
    clearSelectedAdAccountIfNotFoundForStatus(responseStatus, adAccountId);
  }

  return true;
};
